import { getToken } from './tokenUtils';

const RHI_POST_PAYMENT_PATH = '/retail/health-insurance/post-payment';
const RHI_PAYMENT_FAILED_PATH = '/retail/health-insurance/payment-failed';
const RHI_V2_RETURN_PATHS = [
  '/retail/health-insurance/success',
  '/retail/health-insurance/failure',
];

/**
 * Returns true when the current URL is an unauthenticated payment
 * gateway return — either a successful post-payment redirect with a transaction
 * ID, or a direct payment-failed redirect not originating from the in-app state
 * machine.
 *
 * Used in AppProvider to suppress global auth redirects and authenticated
 * queries that would otherwise force a logout before the page can render its
 * static fallback.
 */
export function isUnauthenticatedRhiPaymentReturn(): boolean {
  if (getToken()) return false;

  const { pathname } = window.location;

  if (RHI_V2_RETURN_PATHS.includes(pathname)) {
    const searchParams = new URLSearchParams(window.location.search);
    return !!searchParams.get('quoteId') && !!searchParams.get('planId');
  }

  if (pathname === RHI_POST_PAYMENT_PATH) {
    const searchParams = new URLSearchParams(window.location.search);
    const t = searchParams.get('t');
    return t !== null && t !== '';
  }

  if (pathname === RHI_PAYMENT_FAILED_PATH) {
    // React Router v6 stores navigation state in history.state.usr.
    // A direct gateway return will not have fromPostPayment set.
    const fromPostPayment =
      (window.history.state as { usr?: { fromPostPayment?: boolean } } | null)
        ?.usr?.fromPostPayment === true;
    return !fromPostPayment;
  }

  return false;
}
